export const messages = {
  en: {
    service: {
      search: {
        title: 'Search Condition',
        serviceId: 'serviceId',
        serviceCode: 'serviceCode',
        name: 'name',
        url: 'url',
        method: 'method',
        timeout: 'timeout',
        retryCount: 'retryCount',
        placeholder: 'Please enter service name'
      },
      list: {
        title: 'service List'
      },
      dialog: {
        addTitle: 'Add Service',
        editTitle: 'Edit Service',
        delTitle: 'Delete Service',
        cancel: 'Cancel',
        confirm: 'Confirm'
      },
      form: {
        serviceId: 'serviceId',
        serviceCode: 'serviceCode',
        name: 'name',
        url: 'url',
        method: 'method',
        timeout: 'timeout',
        retryCount: 'retryCount',
      },
      table: {
        serviceId: 'serviceId',
        serviceCode: 'serviceCode',
        name: 'name',
        url: 'url',
        method: 'method',
        timeout: 'timeout',
        retryCount: 'retryCount',
      },
      validate: {
        serviceId: 'Please enter serviceId',
        serviceCode: 'Please enter serviceCode',
        name: 'Please enter name',
        timeout: 'Please enter timeout',
        retryCount: 'Please enter retryCount',
      },
      add: {
        success: 'Add Service success'
      },
      edit: {
        success: 'Edit Service success'
      },
      delete: {
        success: 'Delete Service success',
        confirm: 'Are you sure to delete this service?'
      },
      fetchError: 'Failed to fetch service list'
    }
  },
  zh: {
    service: {
      search: {
        title: '查询条件',
        serviceId: '服务ID',
        serviceCode: '服务编码',
        name: '服务名称',
        url: '目标地址',
        method: '调用方式',
        timeout: '超时时间',
        retryCount: '重试次数',
        placeholder: '请输入服务名称'
      },
      list: {
        title: '服务列表'
      },
      dialog: {
        addTitle: '添加服务',
        editTitle: '编辑服务',
        delTitle: '删除服务',
        cancel: '取消',
        confirm: '确定'
      },
      form: {
        serviceId: '服务ID',
        serviceCode: '服务编码',
        name: '服务名称',
        url: '目标地址',
        method: '调用方式',
        timeout: '超时时间',
        retryCount: '重试次数',
      },
      table: {
        serviceId: '服务ID',
        serviceCode: '服务编码',
        name: '服务名称',
        url: '目标地址',
        method: '调用方式',
        timeout: '超时时间',
        retryCount: '重试次数',
      },
      validate: {
        serviceId: '请输入服务ID',
        serviceCode: '请输入服务编码',
        name: '请输入服务名称',
        timeout: '请输入超时时间',
        retryCount: '请输入重试次数',
      },
      add: {
        success: '添加服务成功'
      },
      edit: {
        success: '编辑服务成功'
      },
      delete: {
        success: '删除服务成功',
        confirm: '确认删除该服务吗？'
      },
      fetchError: '获取服务列表失败'
    }
  }
}